module.exports = __webpack_public_path__ + "img/molitfelnic-1681-pagina-de-titlu-big.b5dbffcf.jpg";